/* hc-marquee.js — pause/play for sections/hc-marquee.liquid.
   The CSS already pauses the drift on hover and under reduced motion; this
   only wires the explicit control: `is-paused` on the .marquee, `aria-pressed`
   and the label on the button. Idempotent, and re-run on section load so the
   Theme Editor keeps working. */
(function () {
  'use strict';

  var LABEL_PAUSE = 'Pause marquee';
  var LABEL_PLAY = 'Play marquee';

  function onClick(event) {
    var button = event.currentTarget;
    var marquee = button.closest('.marquee');
    if (!marquee) return;

    var paused = marquee.classList.toggle('is-paused');
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute('aria-label', paused ? LABEL_PLAY : LABEL_PAUSE);
    button.textContent = paused ? '▶' : '‖';
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-marquee-pause]').forEach(function (button) {
      if (button.dataset.hcMarqueeBound === 'true') return;
      button.dataset.hcMarqueeBound = 'true';
      button.addEventListener('click', onClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
